import styled, { css } from "styled-components";
import {
  colors,
  getTypographyFontStyle,
  device,
} from "../../styles/global.style";

const buttonFontSize = {
  small: getTypographyFontStyle({ variant: "button2", weight: 400 }),
  medium: getTypographyFontStyle({ variant: "button2", weight: 400 }),
  large: getTypographyFontStyle({ variant: "button1", weight: 400 }),
};

const buttonPadding = {
  "sm-small": "10px 20px",
  "sm-medium": "12px 24px",
  "sm-large": "12px 34px",
  "md-small": "10px 30px",
  "md-medium": "12px 36px",
  "md-large": "14px 57.5px",
};

const getFormatStyles = (props) => {
  if (props.format === "outlined") {
    return css`
      background-color: transparent;
      border: 2px solid ${colors.primary};
      color: ${colors.primary};

      &:hover {
        background-color: ${colors.primary};
        color: ${colors.secondary};
        border-color: ${colors.primary};
      }
    `;
  }

  if (props.format === "text") {
    return css`
      background-color: transparent;
      border: none;
      color: ${colors.secondary};

      &:hover {
        background-color: rgba(245, 166, 35, 0.08);
      }
    `;
  }

  // Default: contained
  return css`
    background-color: ${props.disabled ? colors.primaryDark : colors.primary};
    border: 2px solid transparent;
    color: ${colors.secondary};

    &:hover {
      ${!props.disabled &&
      css`
        background-color: ${colors.primaryDark};
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(245, 166, 35, 0.35);
      `}
    }
  `;
};

const PrimaryButton = styled.button`
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  border-radius: 12px;
  display: inline-block;
  padding: 12px 50px;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  ${getTypographyFontStyle({ variant: "button1", weight: 600 })}
  font-weight: 600;
  letter-spacing: 0.8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: ${(props) => buttonPadding[`sm-${props.size}`]};

  ${(props) => getFormatStyles(props)}

  @media ${device.md} {
    padding: ${(props) => buttonPadding[`md-${props.size}`]};
  }

  &:active {
    transform: translateY(0);
  }
`;

export default PrimaryButton;
